import FormInput from 'components/Input/FormInput';
import React, { useCallback } from 'react';

interface IPriceField {
	changePrice: (value: string) => void;
	restaurantsForPrice: string[];
	isCreatedInPos: boolean;
}

const PriceField: React.FC<IPriceField> = ({ changePrice, restaurantsForPrice, isCreatedInPos }) => {
	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '');
			changePrice(onlyDigits);
			return onlyDigits;
		},
		[changePrice],
	);

	return (
		<FormInput
			name="price"
			label="signedPriceLabel"
			getValueFromEvent={handleChange}
			disabled={!restaurantsForPrice.length || isCreatedInPos}
		/>
	);
};

export default React.memo(PriceField);
